export default __webpack_public_path__ + "static/media/double-bubble-dark.9b90d46a.png";